import clsx from "clsx";
import type { ReactNode } from "react";

interface PanelProps {
  title?: string;
  count?: string;
  /** Element to render in the top-right of the header (e.g. a button). */
  headerAction?: ReactNode;
  /** Optional gridArea + extra class names for layout positioning. */
  className?: string;
  /** Children rendered inside `.panel-body` by default; set bodyless to compose freely. */
  children?: ReactNode;
  bodyless?: boolean;
  /** Override the default `<div class="panel-body">` padding. */
  bodyClassName?: string;
}

/**
 * EDGE HUD panel — corner brackets, optional title bar with count, scrollable body.
 * Match docs/mockups/edge_cockpit_v2.html ".panel" anatomy.
 */
export function Panel({
  title,
  count,
  headerAction,
  className,
  children,
  bodyless,
  bodyClassName,
}: PanelProps) {
  return (
    <div className={clsx("panel", className)}>
      <span className="bracket tl" />
      <span className="bracket tr" />
      <span className="bracket bl" />
      <span className="bracket br" />

      {(title || headerAction) && (
        <div className="panel-header">
          {title && (
            <div className="panel-title">
              <span className="panel-title-marker" />
              {title}
            </div>
          )}
          {count !== undefined && <div className="panel-count">{count}</div>}
          {headerAction}
        </div>
      )}

      {bodyless ? children : <div className={clsx("panel-body", bodyClassName)}>{children}</div>}
    </div>
  );
}
